import React, {Component} from 'react'

import DetailHeader from '../../components/generics/DetailHeader';
import ProductionRecipe from '../../components/sessions/ProductionRecipe';
import ListIngredients from '../../components/sessions/ProdListIngredients';
import ListLeftovers from '../../components/sessions/ListLeftovers';
import Modal from '../../components/generics/Modal';

import { finishSession } from "../../store/sessions/api";

import { showErrors} from '../../utils/Helpers';
import Alert from '../../utils/Alert';

export default class RecipeSessionContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recipeAmount: 0,
      ingAmount: [],
      isOpenFinishModal: false,
      producedWeight: 0,
      producedWeightError: '',
      missingIngridientsError: {}
    }

    this.alertRef = React.createRef();
  }

  componentDidMount() {
      let recipeAmount, ingAmount;
      if (this.props.session.temporary_recipe_info){
        recipeAmount = this.props.session.temporary_recipe_info.amount;
        ingAmount = this.props.session.ing_amounts
      } else {
        recipeAmount = this.props.session.recipe.net_weight;
        ingAmount = this.setIngredientAmounts(recipeAmount)
      }
      this.setState({
          recipeAmount,
          producedWeight:recipeAmount,
          ingAmount
      })

  }

  componentDidUpdate(prevProps) {
    if (this.props.session.ing_amounts && this.props.session.ing_amounts !== prevProps.session.ing_amounts) {
      this.setState({ ingAmount: this.props.session.ing_amounts });
    }
  }

  /*** Recipe ***/

  setIngredientAmounts = (recipeAmount) => {
    if(recipeAmount){
      let ingAmount = {};
      const {recipe} = this.props.session;
      recipe.ingredients.forEach((i)=>{
        ingAmount[i.item.id] = i.amount;
      })
      return ingAmount
    }
  };

  handleRecipeAmountChange = (event) => {
    let recipeAmount = event.target.value
    this.setState({
      recipeAmount,
      producedWeight:recipeAmount,
    })
  };

  handleRecipeAmountBlur = () => {
    let data =  new FormData()
    data.append('recipeAmount', this.state.recipeAmount);
    this.props.updateProdSession(this.props.session.id, data)
  };


  /*** Finish session **/

  openFinishSessionModal = () =>{
    this.setState({isOpenFinishSessionModal: true});
  };

  handleProducedWeightChange = (event) =>{
    let producedWeightError = ''
    if(event.target.value=== ''){
      producedWeightError = 'This field is required'
    }
    this.setState({
      producedWeight: event.target.value,
      producedWeightError
    })
  };

  finishSession = () =>{
    if (this.state.producedWeight !== ''){
      let data =  new FormData()
      data.append('recipe_amount', this.state.producedWeight);
      finishSession(this.props.session.id, data).then((r) => {
        this.props.history.push('/session/' + this.props.session.id + '/labels?finish_session=true');
      }).catch((error) => {
        if (error.response.status === 400 && 'missing_ingredients' in error.response.data) {
          this.setState({missingIngridientsError: error.response.data.missing_ingredients})
        } else {
          showErrors(error, this.alertRef);
        }
        this.setState({isOpenFinishModal: false})
      });

    }
  };

  openFinishSessionModal = () =>{
    if(this.props.hasError()){
      this.alertRef.current.sendAlert('Please correct the errors to finish the session.');
    } else {
      this.setState({
        isOpenFinishModal: true
      })
    }
  };

  render () {
      const {recipe} = this.props.session
      return(
        <div>
          <Alert ref={this.alertRef}/>
          <DetailHeader title="Production Session"
            actionTitle="Finish"
            action ={this.openFinishSessionModal}
            actionClass="btn btn-success m-0"
            actionIconClass="fa fa-check mr-05"

            col1Title="Recipe"
            col1Desc={recipe.item.name}
            col2Title="Default weight"
            col2Desc={recipe.net_weight + ' ' +  recipe.item.measure_unit}

            appendWarningMessage={this.props.session.intermediate_labels}
            warningMessage={`You can't add or remove ingredients, because you have already printed products labels.`}/>
          {this.state.missingIngridientsError.length &&
          <div className='card'>
            <div className="card-header alert-danger">
              <h5>Some ingredients are missing to be able to end the session:</h5>
              {this.state.missingIngridientsError.map((item, index) => <li key={index}>{`${item.name}: ${item.value} ${item.unit_of_measure}`}</li>)}
            </div>
          </div>}
          <ProductionRecipe
            recipe={recipe}
            ingAmount={this.state.ingAmount}
            recipeAmount={this.state.recipeAmount}
            onRecipeAmountChange={this.handleRecipeAmountChange}
            onRecipeAmountBlur={this.handleRecipeAmountBlur}
            inventoryToAdd={this.props.inventoryToAdd}
            onInventoryAddSubmit={this.props.onInventoryAddSubmit}
            onInventoryToAddChange={this.props.onInventoryToAddChange}
            onScanItem={this.props.onScannedInventory}
            onScanError={this.props.onScanError}
            scanResult={this.props.scanResult}
            scanStatus={this.props.scanStatus}
            loadingIngredient={this.props.loadingIngredient}
          />
          <ListIngredients
              title="Selected Ingredients"
              ingredients={this.props.ingredients}
              changeAmountError={this.props.listIngredientsError}
              onIngredientDelete={this.props.onIngredientDelete}
              onIngredientAmountChange={this.props.onIngredientAmountChange}
              onBlur={this.props.onIngredientAmountBlur}

            />
            <ListLeftovers
              title="Leftovers"
              leftovers={this.props.leftovers}
              toggleCheckBox={this.props.onLeftoverToggleCheckBox}
              onLeftoverAmountChange={this.props.onLeftoverAmountChange}
              leftoverError={this.props.leftoverError}
              leftoverWarning={this.props.leftoverWarning}
              onAmountBlur={this.props.onLeftoverAmountBlur}
            />
          <Modal
            closeModal={() => this.setState({isOpenFinishModal: false})}
            isModalOpen={this.state.isOpenFinishModal}
            onConfirm={this.finishSession}
            onCancel={() => this.setState({isOpenFinishModal: false})}
            header="Finish session"
            onConfirmButtonText="Continue"
            onCancelButtonText="Cancel"
            >
            <div className="card-block pb-0">
              <h6>Quantity produced</h6>
              <div className="row">
                <div className="form-group col-10">
                    <div className="input-group">
                      <input placeholder="Quantity"
                        type="number"
                        className="z-index-0 form-control"
                        value={this.state.producedWeight}
                        onChange={this.handleProducedWeightChange}/>
                      <div className="input-group-addon">{recipe.item.measure_unit ? recipe.item.measure_unit : 'lb' }</div>
                    </div>
                    {this.state.producedWeightError !== '' && <em className="error form-control-feedback">{this.state.producedWeightError}</em>  }
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )
  }
};
